module.exports = __webpack_public_path__ + "img/img2.c626c492.png";